// extracted by mini-css-extract-plugin
export default {"treeEditor":"treeEditor_N5SIR"};